
import { Link } from 'react-router-dom';

export default function Footer() {
  const handleLinkClick = () => {
    if (typeof window !== 'undefined' && typeof window.scrollTo === 'function') {
      window.scrollTo({ top: 0, behavior: 'smooth' });
    }
  };

  return (
    <footer className="bg-gradient-to-r from-gray-800 to-gray-900 text-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-8 py-10 sm:py-16">
        <div className="flex flex-col items-center text-center">
          {/* Brand Section */}
          <Link to="/" onClick={handleLinkClick} className="cursor-pointer">
            <h1
              className="text-2xl sm:text-3xl font-bold text-red-100 tracking-wide hover:text-red-300 transition-colors duration-300 mb-4 sm:mb-6"
              style={{ fontFamily: "'Playfair Display', serif" }}
            >
              CAPITAL PUNISHMENT
            </h1>
          </Link>
          
          <blockquote className="border-l-4 border-red-500 pl-4 italic mb-6 sm:mb-8 max-w-sm sm:max-w-none">
            <p
              className="text-gray-300 mb-2 text-base sm:text-lg"
              style={{ fontFamily: "'Playfair Display', serif" }}
            >
              "Num mundo louco, só os loucos são sãos"
            </p>
            <footer className="text-gray-400 text-sm">—Akira Kurosawa</footer>
          </blockquote>

          {/* Instagram */}
          <a
            href="https://www.instagram.com/rafa_aragonez/"
            target="_blank"
            rel="noopener noreferrer"
            className="text-gray-300 hover:text-red-400 transition-colors duration-300 cursor-pointer flex items-center gap-2 mb-6 sm:mb-8"
          >
            <i className="ri-instagram-line text-lg"></i>
            Instagram
          </a>
        </div>

        {/* Bottom Bar */}
        <div className="border-t border-gray-700 mt-4 pt-6 sm:pt-8">
          <div className="flex flex-col items-center justify-center">
            <div className="text-gray-400 text-xs sm:text-sm text-center px-4">
              © 2026 Capital Punishment Blog. Todos os direitos reservados.
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}
